import { render, staticRenderFns } from "./event_type.vue?vue&type=template&id=5859df21&scoped=true"
import script from "./event_type.vue?vue&type=script&lang=js"
export * from "./event_type.vue?vue&type=script&lang=js"
import style0 from "./event_type.vue?vue&type=style&index=0&id=5859df21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859df21",
  null
  
)

export default component.exports